export { default } from './toImmutableIterable'
